import { getGuessStatuses } from './statuses'
import { GAME_LINK, GAME_TITLE } from '../constants/strings'
import { Share } from '@capacitor/share';
import { isMobile } from 'react-device-detect';
import { date, solution, solutionIndex } from './words';

export const shareStatus = async (guesses: string[], lost: boolean) => {
  if (isMobile) {
    navigator.clipboard.writeText(`#BTSHeardle${solutionIndex} ${lost ? 'X' : guesses.length}/7\n\n` +
      generateEmojiGrid(guesses) + `\n\n${GAME_LINK}`)
    await Share.share({
      title: "BTSHeardle Result",
      text: `#BTSHeardle${solutionIndex} ${lost ? 'X' : guesses.length}/7\n\n` +
        generateEmojiGrid(guesses) + `\n\n${GAME_LINK}`
    }
    );
  } else {
    navigator.clipboard.writeText(`#BTSHeardle${solutionIndex} ${lost ? 'X' : guesses.length}/7\n\n` +
      generateEmojiGrid(guesses) + `\n\n${GAME_LINK}`)
  }
}

export const generateEmojiGrid = (guesses: string[]) => {
  return '🔊' + guesses
    .map((guess) => {
      if (guess == "SKIPPED") {
        return '⬛️'
      }
      if (guess == solution) {
        return '🟪'
      }
      if (guess != solution) {
        return '🟥'
      }
    }
    )
    .join('')
}
